const { TASKS } = require('../productTasks/consts');
const { TASK_TYPE } = require('../tasks/consts');
const { taskManager } = require('../tasks/taskManager');

function onProductTasksAfterInsert(task) {
  console.log('onTaskCollectionAfterinsert ', task);
  if (task.type === TASK_TYPE.SCHEDULED) {
    return; //cron job will run them later on
  }
  return taskManager().processTask(task, TASKS);
}

module.exports = {
  onProductTasksAfterInsert,
};
